<script setup>
import { computed } from "vue"

const props = defineProps({
  color: {
    type: String,
    default: null,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  buttonType: {
    type: String,
    default: "button",
  },
})

const slotClass = computed(() => {
  return props.isLoading ? "opacity-0" : ""
})
</script>

<template>
  <button
    :type="buttonType"
    class="btn"
    :class="[color ? 'internal-btn-' + color : '']"
    style="position: relative"
    :disabled="isDisabled"
  >
    <span v-show="isLoading" class="absolute">
      <v-icon name="ri-loader-5-line" class="ov-spin" />
    </span>
    <span :class="slotClass"><slot></slot></span>
  </button>
</template>

<style scoped lang="postcss">

.internal-btn-primary:not(:disabled) {
  @apply btn-primary text-white dark:text-primary-content;
}

.internal-btn-secondary:not(:disabled) {
  @apply btn-secondary text-secondary-content;
}

.internal-btn-accent:not(:disabled) {
  @apply btn-accent text-accent-content;
}

.internal-btn-neutral:not(:disabled) {
  @apply btn-neutral text-neutral-content;
}

.internal-btn-success:not(:disabled) {
  @apply btn-success text-success-content;
}

.internal-btn-warning:not(:disabled) {
  @apply btn-warning text-warning-content;
}

.internal-btn-error:not(:disabled) {
  @apply btn-error text-error-content;
}

.internal-btn-info:not(:disabled) {
  @apply btn-info text-info-content;
}

.internal-btn-ghost:not(:disabled) {
  @apply btn-ghost;
}

.internal-btn-link:not(:disabled) {
  @apply btn-link;
}

</style>
